import locales from "./locales/locales";
import router from './routes/routes'

export const DirectorsModule = {
	name: 'directors',
	routes: router,
	locales: locales,
}